import React from "react";

const Intermezzo = ({ image, quote, id }) => {
  let IntermezzoInhalt;
  if (id === "start") {
    IntermezzoInhalt = `${quote}<footer id="dichterAbsender">
          <cite>
            <h1>Michael Stauffer, Dichter</h1>
          </cite>
        </footer>`;
  } else {
    IntermezzoInhalt = quote;
  }

  return (
    <section className="intermezzo" id={id} style={{ background: "#00f" }}>
      <blockquote
        //className="normal"
        className="normal"
        dangerouslySetInnerHTML={{ __html: IntermezzoInhalt }}
      ></blockquote>

      <img
        style={{ objectFit: "cover", height: "100%" }}
        className="intermezzobild mCS_img_loaded"
        src={image}
        alt=""
      />
    </section>
  );
};

export default Intermezzo;
